import { render, staticRenderFns } from "./HistorySummary.vue?vue&type=template&id=4dd3d723"
import script from "./HistorySummary.vue?vue&type=script&lang=js"
export * from "./HistorySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports